<div fxLayout="column" fxLayoutGap="20px">
  <app-page-header title="Concursos" variant="responsive-md">
    <ng-container *ngIf="canModify()">
      <button mat-raised-button color="primary" routerLink="/concurso/cadastro">
        <mat-icon>add</mat-icon> Adicionar
      </button>
      &nbsp;
      <app-export-button (export)="exportar()"></app-export-button>
    </ng-container>
    <ng-container *ngIf="isCCPT()">
      <mat-form-field appearance="outline">
        <mat-label>Exibir</mat-label>
        <mat-select name="filtroCcpt" [(value)]="filtroCcptSelecionado" (selectionChange)="getData()">
          <mat-option *ngFor="let type of filtroCcpt | keyvalue" [value]="type.key">
            {{ type.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="isCACP()">
      <mat-form-field appearance="outline">
        <mat-label>Filtrar</mat-label>
        <mat-select name="filtroCacp" [(value)]="filtroCacpSelecionado" (selectionChange)="getData()">
          <mat-option *ngFor="let type of filtroCacp | keyvalue" [value]="type.key">
            {{ type.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </app-page-header>
  <div fxLayout.lt-md="column" fxLayoutGap="20px">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Filtrar por etapa atual</mat-label>
      <mat-select name="filtroEtapa" [(value)]="filtroAndamentoSelecionado" (selectionChange)="getData()">
        <mat-option value="">Todas as etapas</mat-option>
        <mat-option *ngFor="let enum of tipoAndamento | keyvalue" [value]="enum.key">
          {{ enum.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Tipo de concurso</mat-label>
      <mat-select name="filtroTipoConcurso" [(value)]="filtroTipoConcursoSelecionado" (selectionChange)="getData()">
        <mat-option value="">Todos os Tipos de Concurso</mat-option>
        <mat-option
          *ngFor="let enum of (showTipoConcursoDTA() ? tipoConcursoDTA : tipoConcurso) | keyvalue"
          [value]="enum.key">
          {{ enum.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="campus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Unidade</th>
        <td mat-cell *matCellDef="let row" [matTooltip]="row.campus">{{ row.siglaUnidade }}</td>
      </ng-container>
      <ng-container matColumnDef="processo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Processo</th>
        <td mat-cell *matCellDef="let row">{{ row.processo }}</td>
      </ng-container>
      <ng-container matColumnDef="titulo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
        <td mat-cell *matCellDef="let row">{{ row.titulo }}</td>
      </ng-container>
      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Inscrição</th>
        <td mat-cell *matCellDef="let row">
          {{ row.inicio | date : 'dd/MM/yyyy' }} a {{ row.fim | date : 'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ getTipo(row.tipo) }}</td>
      </ng-container>
      <ng-container matColumnDef="andamento">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Etapa</th>
        <td mat-cell *matCellDef="let row">{{ row.andamento }}<br />{{ row.andamentoData | date : 'dd/MM/yyyy' }}</td>
      </ng-container>
      <ng-container matColumnDef="action" *ngIf="canOpenOptions()">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-stroked-button
            color="basic"
            routerLink="/concurso/{{ row.id }}/inscricoes"
            title="Inscrições"
            (click)="$event.stopPropagation()">
            {{ row.quantidadeInscritos }}
          </button>
        </td>
      </ng-container>
      <ng-container matColumnDef="action2" *ngIf="canOpenOptions()">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="basic" routerLink="/concurso/{{ row.id }}/dados" title="Abrir concurso"
            (click)="$event.stopPropagation()">
            <mat-icon>settings</mat-icon>
          </button>
        </td>
      </ng-container>
      <ng-container *ngIf="isCACP(); then perfilCacp; else perfilCcpt"></ng-container>
      <ng-template #perfilCcpt>
        <ng-container matColumnDef="action" *ngIf="!canOpenOptions()">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              *ngIf="filtroCcptSelecionado === 'TODOS'"
              mat-stroked-button
              color="basic"
              routerLink="/concurso/{{ row.id }}/inscricoes"
              title="Inscrições"
              (click)="$event.stopPropagation()">
              {{ row.quantidadeInscritos }}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="action2" *ngIf="!canOpenOptions()">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              *ngIf="filtroCcptSelecionado !== 'TODOS'"
              mat-icon-button
              color="basic"
              routerLink="/concurso/{{ row.id }}/inscricoes"
              title="Inscrições"
              (click)="$event.stopPropagation()">
              {{ row.quantidadeInscritos }}
            </button>
          </td>
        </ng-container>
      </ng-template>
      <ng-template #perfilCacp>
        <ng-container matColumnDef="action" *ngIf="!canOpenOptions()">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              *ngIf="filtroCacpSelecionado === 'TODOS'"
              mat-stroked-button
              color="basic"
              routerLink="/concurso/{{ row.id }}/inscricoes"
              title="Inscrições"
              (click)="$event.stopPropagation()">
              {{ row.quantidadeInscritos }}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="action2" *ngIf="!canOpenOptions()">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              *ngIf="filtroCacpSelecionado !== 'TODOS'"
              mat-icon-button
              color="basic"
              routerLink="/concurso/{{ row.id }}/inscricoes"
              title="Inscrições"
              (click)="$event.stopPropagation()">
              {{ row.quantidadeInscritos }}
            </button>
          </td>
        </ng-container>
      </ng-template>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"
        class="row-clickable"
        (click)="abrirConcurso(row)"
        role="link"
        [attr.aria-label]="'Abrir concurso ' + row.titulo"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements" [pageSize]="20"></app-default-paginator>
  </div>
</div>
